import { useQuery } from '@tanstack/react-query';
import { AmountsPreviewOutput, AmountsPreviewQuery } from './types';
import { getAmountsPreview } from './getAmountsPreview';

export function useAmountsPreviewQuery(props: AmountsPreviewQuery) {
  return useQuery<AmountsPreviewOutput>({
    queryKey: ['amounts-preview', props.companyId, props.driverId, props.yearMonth],
    queryFn: async () => {
      const { data } = await getAmountsPreview(props)
      return data;
    },
    enabled: !!props.companyId && !!props.driverId && !!props.yearMonth,
    // These amounts are a snapshot written by the timesheet calculation, so any cached copy
    // silently outlives a recalculation. The modal is opened rarely — always refetch on mount.
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
